<template>
  <div class="e2e-gfx3d-board-modification"></div>
</template> 

<script>
import { doModification } from "./gfx3d";
export default {
  name: "fragment-gfx3d-board-modification",
  props: ["fragment"],
  data() {
    return {};
  },
  mounted() {
    let fragment = this.fragment;
    doModification({
      script: fragment.script,
      base64: fragment.base64
    });
  }
};
</script>
  

<style scoped>
</style> 

